<div [formGroup]="recourseCampaignEditForm">
  <pas-system-process [cancelButton]="false" #processComponent></pas-system-process>
  <!-- Overview 1 -->
  <div class="row" style="padding-left: 10px">
    <div class="col-12 col-lg-4">
      <div class="row">
        <table class="tableLayout">
          <tr>
            <td>
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_RECOURSE_ID' | translate }}</b>
              </label>
            </td>
            <td>
              <label>{{ recourseCampaignEditForm.get('campaignRecourseId').value }}</label>
            </td>
          </tr>
          <tr>
            <td>
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_CREATION_DATE' | translate }}</b>
              </label>
            </td>
            <td>
              <label>{{ recourseCampaignEditForm.get('campaignCreateDate').value }}</label>
            </td>
          </tr>
          <tr>
            <td>
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_TARGET_CARS' | translate }}</b>
              </label>
            </td>
            <td>
              <label>{{ recourseCampaignEditForm.get('targetCars').value }}</label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="row">
        <table class="tableLayout">
          <tr>
            <td class="noPadding">
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_OPERATION_ID' | translate }}</b>
              </label>
            </td>
            <td class="noPadding">
              <label>{{ recourseCampaignEditForm.get('operationId').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding">
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_YEAR' | translate }}</b>
              </label>
            </td>
            <td class="noPadding">
              <label>{{ recourseCampaignEditForm.get('businessYear').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding">
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_FULFILLMENT_DEGREE' | translate }}</b>
              </label>
            </td>
            <td class="noPadding">
              <label>{{ recourseCampaignEditForm.get('fulfillmentDegree').value }}</label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="row">
        <table class="tableLayout" style="border-collapse: collapse; width: auto">
          <tr>
            <td class="noPadding">
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_TOPIC' | translate }}</b>
              </label>
            </td>
            <td class="noPadding">
              <label>{{ recourseCampaignEditForm.get('topic').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding">
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_PUBLISHED_DATE' | translate }}</b>
              </label>
            </td>
            <td class="noPadding">
              <label>{{ recourseCampaignEditForm.get('publishedDate').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding">
              <label>
                <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS' | translate }}</b>
              </label>
            </td>
            <td class="noPadding">
              <label>
                {{
                  recourseCampaignEditForm.get('campaignCostsPrognosis').value | currency: '' : '' : '' : userLanguage
                }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="row">
          <pas-select
            [formControl]="$any(recourseCampaignEditForm.get('recourseCampaignState'))"
            [options]="recourseCampaingStore.recourseCampaignStateListForSelection"
            (ngModelChange)="onSelectRecourseCampaignState(recourseCampaignStateSelection.selectedOption)"
            id="recourseCampaignState"
            #recourseCampaignStateSelection
            style="padding: 0px; width: 250px"
            placeholder="{{ 'CHOOSE_ONE' | translate }}"
            subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_FKCAMPAIGN_STATE_ID' | translate }}"
            valuesProp="value"></pas-select>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="row">
          <pas-select
            [formControl]="$any(recourseCampaignEditForm.get('assignee'))"
            [options]="recourseCampaingStore.userByRightListForSelection"
            #stateSelection
            style="padding: 0px; width: 250px"
            placeholder="{{ 'CHOOSE_ONE' | translate }}"
            subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_ASSIGNEE' | translate }}"
            valuesProp="value"></pas-select>
        </div>
      </div>
    </div>
  </div>

  <!-- General data -->
  <pas-accordion [isClosed]="false" title="{{ 'CAMPAIGN_DETAILS_GENERAL_INFO' | translate }}">
    <ng-template pasAccordionBody>
      <div class="container">
        <div class="row gy-3">
          <!-- Row 1 -->
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('orderType'))"
              [validationMessages]="validationMessages"
              formControlName="orderType"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_ORDER_TYPE' | translate }}"></pas-input>
          </div>
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('markets'))"
              [validationMessages]="validationMessages"
              formControlName="markets"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_AFFECTED_MARKETS' | translate }}"></pas-input>
          </div>
          <div class="col-4">
            <pas-input-number
              [disabled]="recourseCampaignEditForm.get('affectedVehicles').disabled"
              [formControl]="$any(recourseCampaignEditForm.get('affectedVehicles'))"
              [maxLength]="10"
              formControlName="affectedVehicles"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_AFFECTED_VEHICLES' | translate }}"></pas-input-number>
          </div>
          <!-- Row 2 -->
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('supplier'))"
              [hasClearBtn]="true"
              [validationMessages]="validationMessages"
              [maxLength]="6"
              (ngModelChange)="onSupplierChanged()"
              formControlName="supplier"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_SUPPLIER' | translate }}"></pas-input>
          </div>
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('supplierName'))"
              formControlName="supplierName"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_NAME1' | translate }}"></pas-input>
          </div>
          <div class="col-4"></div>
          <!-- Row 3 -->
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('contactInternal'))"
              formControlName="contactInternal"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_INTERNAL_CONTACT' | translate }}"></pas-input>
          </div>
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('contactExternal'))"
              formControlName="contactExternal"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_EXTERNAL_CONTACT' | translate }}"></pas-input>
          </div>
          <div class="col-4"></div>
          <!-- Row 4 -->
          <div class="col-4">
            <pas-input
              [formControl]="$any(recourseCampaignEditForm.get('recourseCoordination'))"
              [validationMessages]="validationMessages"
              formControlName="recourseCoordination"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_EXAMINATION_REGRESS_E_P' | translate }}"></pas-input>
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>
          <!-- Row 5 -->
          <div class="col-4">
            <pas-input-number
              [disabled]="recourseCampaignEditForm.get('recourseActualCostsEur').disabled"
              [decimalCount]="2"
              [decimalSeparator]="decimalSeparator"
              [formControl]="$any(recourseCampaignEditForm.get('recourseActualCostsEur'))"
              formControlName="recourseActualCostsEur"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS_ACTUAL' | translate }}"></pas-input-number>
          </div>
          <div class="col-4">
            <pas-input-number
              [disabled]="recourseCampaignEditForm.get('costsPrognosisInternal').disabled"
              [decimalCount]="2"
              [decimalSeparator]="decimalSeparator"
              [formControl]="$any(recourseCampaignEditForm.get('costsPrognosisInternal'))"
              formControlName="costsPrognosisInternal"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS_PROGNOSIS' | translate }}"></pas-input-number>
          </div>
          <div class="col-4">
            <pas-datetime-picker
              [disabled]="recourseCampaignEditForm.get('costEditDate').disabled"
              [formControl]="$any(recourseCampaignEditForm.get('costEditDate'))"
              locale="de"
              pickerType="date"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_CHANGE_DATE' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
          </div>
        </div>

        <div class="col-12">
          <ag-grid-angular
            [gridOptions]="generalAttachmentsGridOptions"
            [columnDefs]="generalDataColumnDefs"
            [defaultColDef]="defaultColDef"
            [components]="frameworkComponents"
            [rowData]="generalDataRowData"
            (firstDataRendered)="onFirstDataRendered($event)"
            (gridReady)="onGeneralDataGridReady($event)"
            (gridSizeChanged)="onGridSizeChanged($event)"
            class="ag-theme-alpine_customize"
            id="generalDataTable"
            domLayout="autoHeight"
            style="width: 100%"></ag-grid-angular>
        </div>

        <div class="row g-0" style="padding-top: 15px"></div>
        <div style="padding-left: 10px">
          <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_PARTSREQUEST' | translate }}</b>
        </div>
        <div class="row g-0" style="padding-top: 15px"></div>
        <div class="row g-3">
          <div class="col-4">
            <pas-radio-button
              [formControl]="$any(recourseCampaignEditForm.get('partsRequest'))"
              name="radio_def"
              label="{{ 'YES' | translate }}"
              selectionValue="1"
              style="padding-left: 10px"></pas-radio-button>
            <pas-radio-button
              [formControl]="$any(recourseCampaignEditForm.get('partsRequest'))"
              name="radio_def"
              label="{{ 'NO' | translate }}"
              selectionValue="0"
              style="padding-left: 20px"></pas-radio-button>
          </div>
          <div class="col-4" style="margin-left: 10px">
            @if (hasRightsForPartsRequestButton) {
              <pas-button
                (click)="forwardToQpp()"
                text="{{ 'RECOURSE_CAMPAIGN_DETAIL_PARTSREQUEST_QPP' | translate }}"
                width="250px"></pas-button>
            }
          </div>
          <div class="col-4"></div>
        </div>
      </div>
      <div class="row g-3"></div>
      <div style="padding-left: 10px; padding-right: 10px">
        <pas-textarea
          [formControl]="$any(recourseCampaignEditForm.get('comment'))"
          [cols]="50"
          [maxLength]="3000"
          subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_NOTE' | translate }}"></pas-textarea>
      </div>
    </ng-template>
  </pas-accordion>

  <pas-accordion [isClosed]="false" title="{{ 'RECOURSE_CAMPAIGN_DETAIL_COMPLAINT' | translate }}">
    <ng-template pasAccordionBody>
      <div class="container">
        <div class="row gy-3">
          <div class="col-4">
            <pas-datetime-picker
              [disabled]="recourseCampaignEditForm.get('complaintDate').disabled"
              [formControl]="$any(recourseCampaignEditForm.get('complaintDate'))"
              locale="de"
              pickerType="date"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_COMPLAINT_CHANGE_DATE' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>
          <div class="col-12">
            <ag-grid-angular
              [gridOptions]="complaintAttachmentsGridOptions"
              [columnDefs]="complaintTableColumnDefs"
              [defaultColDef]="defaultColDef"
              [components]="frameworkComponents"
              [rowData]="complaintTableRowData"
              (firstDataRendered)="onFirstDataRendered($event)"
              (gridReady)="onComplaintGridReady($event)"
              (gridSizeChanged)="onGridSizeChanged($event)"
              class="ag-theme-alpine_customize"
              id="complaintTable"
              domLayout="autoHeight"
              style="width: 100%"></ag-grid-angular>
          </div>
        </div>
      </div>
    </ng-template>
  </pas-accordion>

  <pas-accordion [isClosed]="false" title="{{ 'RECOURSE_CAMPAIGN_DETAIL_RECOURSE_REQUEST' | translate }}">
    <ng-template pasAccordionBody>
      <div class="container">
        <div class="row gy-3">
          <div class="col-4">
            <pas-datetime-picker
              [disabled]="recourseCampaignEditForm.get('recourseClaimDate').disabled"
              [formControl]="$any(recourseCampaignEditForm.get('recourseClaimDate'))"
              locale="de"
              pickerType="date"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_RECOURSE_REQUEST_CHANGE_DATE' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>

          <div class="col-12">
            <ag-grid-angular
              [gridOptions]="recourseClaimAttachmentsGridOptions"
              [columnDefs]="recourseClaimTableColumnDefs"
              [defaultColDef]="defaultColDef"
              [components]="frameworkComponents"
              [rowData]="recourseClaimTableRowData"
              (firstDataRendered)="onFirstDataRendered($event)"
              (gridReady)="onRecourseClaimGridReady($event)"
              (gridSizeChanged)="onGridSizeChanged($event)"
              class="ag-theme-alpine_customize"
              id="recourseClaimTable"
              domLayout="autoHeight"
              style="width: 100%"></ag-grid-angular>
          </div>
        </div>
      </div>
    </ng-template>
  </pas-accordion>

  <!-- NEGOTIATIONS -->
  <pas-accordion [isClosed]="false" title="{{ 'RECOURSE_CAMPAIGN_DETAIL_NEGOTIATION' | translate }}">
    <ng-template pasAccordionBody>
      <div class="container">
        <div class="row gy-3">
          <div class="col-4">
            <pas-datetime-picker
              [disabled]="recourseCampaignEditForm.get('negotiationDate').disabled"
              [formControl]="$any(recourseCampaignEditForm.get('negotiationDate'))"
              #negotiationDate
              locale="de"
              pickerType="date"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_NEGOTIATION_CHANGE_DATE' | translate }}"
              confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
          </div>

          <div class="col-4"></div>
          <div class="col-4"></div>

          <div class="col-4" style="padding: 3px">
            <ul class="negotiation">
              @for (newSelectednegotiationDate of data.recourseCampaignNegotiations; track newSelectednegotiationDate) {
                <li
                  [class.selected]="newSelectednegotiationDate === selectedNegotiationDate"
                  (click)="onSelectNegotiationDate(newSelectednegotiationDate)"
                  style="width: 100%">
                  <span>
                    {{ dateFormatPipe.transformDateToGermanFormat(newSelectednegotiationDate.negotiationDate) }}
                  </span>
                  @if (!campaignStateCancelledOrInternalFault()) {
                    <button
                      (click)="
                        deleteNegotiationDate(newSelectednegotiationDate.negotiationDate); $event.stopPropagation()
                      "
                      class="negotiation-button delete">
                      x
                    </button>
                  }
                </li>
              }
            </ul>
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>
        </div>

        <div class="col-12">
          <ag-grid-angular
            [gridOptions]="negotiationAttachmentsGridOptions"
            [columnDefs]="recourseNegotiationTableColumnDefs"
            [defaultColDef]="defaultColDef"
            [components]="frameworkComponents"
            [rowData]="recourseNegotiationTableRowData"
            (firstDataRendered)="onFirstDataRendered($event)"
            (gridReady)="onNegotiationGridReady($event)"
            (gridSizeChanged)="onGridSizeChanged($event)"
            class="ag-theme-alpine_customize"
            id="recourseNegotiationTable"
            domLayout="autoHeight"
            style="width: 100%"></ag-grid-angular>
        </div>
      </div>
    </ng-template>
  </pas-accordion>

  <!-- BOOKINGS -->
  <pas-accordion [isClosed]="false" title="{{ 'RECOURSE_CAMPAIGN_DETAIL_BOOKINGS' | translate }}">
    <ng-template pasAccordionBody>
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="row">
            <table class="tableLayout">
              <tr>
                <td>
                  <label class="ml-3">
                    <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_TOTAL_REVENUES' | translate }}</b>
                  </label>
                </td>
                <td>
                  <label [ngClass]="{ 'red-characters': recourseCampaignEditForm.get('totalRevenue').value < 0 }">
                    {{ recourseCampaignEditForm.get('totalRevenue').value | currency: '' : '' : '' : userLanguage }}
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label class="ml-3">
                    <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_REVENUES_CURRENT_BUSINESS_YEAR' | translate }}</b>
                  </label>
                </td>
                <td>
                  <label
                    [ngClass]="{
                      'red-characters': recourseCampaignEditForm.get('revenuesCurrentBusinessYear').value < 0,
                    }">
                    {{
                      recourseCampaignEditForm.get('revenuesCurrentBusinessYear').value
                        | currency: '' : '' : '' : userLanguage
                    }}
                  </label>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="row">
            <table class="tableLayout">
              <tr>
                <td>
                  <label class="ml-3">
                    <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_OUTSTANDING_REVENUES' | translate }}</b>
                  </label>
                </td>
                <td>
                  <label
                    [ngClass]="{ 'red-characters': recourseCampaignEditForm.get('outstandingRevenues').value < 0 }">
                    {{
                      recourseCampaignEditForm.get('outstandingRevenues').value | currency: '' : '' : '' : userLanguage
                    }}
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label class="ml-3">
                    <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_REVENUES_PREVIOUS_YEARS' | translate }}</b>
                  </label>
                </td>
                <td>
                  <label
                    [ngClass]="{ 'red-characters': recourseCampaignEditForm.get('revenuesPreviousYears').value < 0 }">
                    {{
                      recourseCampaignEditForm.get('revenuesPreviousYears').value
                        | currency: '' : '' : '' : userLanguage
                    }}
                  </label>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="clearfix hidden-sm-up"></div>
        <div class="col-12 col-lg-4">
          <div class="row"></div>
        </div>
      </div>

      <div class="container">
        <div class="row gy-3">
          <div class="col-4">
            <pas-input-number
              [disabled]="recourseCampaignEditForm.get('revenueOthersEur').disabled"
              [decimalCount]="2"
              [decimalSeparator]="decimalSeparator"
              [formControl]="$any(recourseCampaignEditForm.get('revenueOthersEur'))"
              class="col-12"
              formControlName="revenueOthersEur"
              subLabel="{{ 'RECOURSE_CAMPAIGN_DETAIL_OTHER_REVENUES' | translate }}"></pas-input-number>
          </div>
          <div class="col-4"></div>
          <div class="col-4"></div>
        </div>

        <div class="col-12" style="padding-top: 15px"></div>

        <label class="ml-3">
          <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_HEADLINE' | translate }}</b>
        </label>

        <div class="col-12">
          <!-- Row count of 8 fits inside 300px, which was the original value -->
          <ag-grid-angular
            [gridOptions]="bookingGridOptions"
            [columnDefs]="bookingTableColumnDefs"
            [defaultColDef]="defaultColDef"
            [components]="frameworkComponents"
            [rowData]="bookingTableRowData"
            [getContextMenuItems]=""
            [domLayout]="data?.bookings?.length > 8 ? 'normal' : 'autoHeight'"
            [style.height]="data?.bookings?.length > 8 ? '300px' : 'none'"
            (firstDataRendered)="onFirstDataRendered($event)"
            (gridReady)="onBookingGridReady($event)"
            (gridSizeChanged)="onGridSizeChanged($event)"
            class="ag-theme-alpine_customize"
            id="bookingTable"
            style="width: 100%"></ag-grid-angular>
        </div>
      </div>
    </ng-template>
  </pas-accordion>
</div>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          <li [ngClass]="isRecourseCampaignEditSaveEnabled() ? 'nav-item' : 'nav-item disabled'">
            <a (click)="onBtnSave()" class="nav-link link-sidebar">
              <i class="material-icons">save</i>
              <span class="hidden-md-down" ui-test-id="saveBtn">{{ 'SAVE' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a (click)="onBtnCancel()" class="nav-link link-sidebar">
              <i class="material-icons">cancel</i>
              <span class="hidden-md-down" ui-test-id="cancelBtn">{{ 'CANCEL' | translate }}</span>
            </a>
          </li>
          @if (isCreateManualBookingVisible()) {
            <li [ngClass]="isCreateManualBookingEnabled() ? 'nav-item' : 'nav-item disabled'">
              <a (click)="onBtnCreateManualBooking()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down" ui-test-id="createManualBookingBtn">
                  {{ 'BOOKING_DETAILS_CREATE_MANUAL_BOOKING' | translate }}
                </span>
              </a>
            </li>
          }
          @if (canUserUploadAttachments()) {
            <li [ngClass]="isAttachmentButtonEnabled() ? 'nav-item' : 'nav-item disabled'">
              <a (click)="onUploadAttachments()" class="nav-link link-sidebar">
                <i class="material-icons">file_upload</i>
                <span class="hidden-md-down" ui-test-id="uploadAttachmentBtn">
                  {{ 'UPLOAD_ATTACHMENT' | translate }}
                </span>
              </a>
            </li>
          }
          @if (userHasWorkflowRight()) {
            <li [ngClass]="'nav-item'">
              <a (click)="onDuplicateCampaignClicked()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down" ui-test-id="duplicateCampaignBtn">
                  {{ 'DUPLICATE_CAMPAIGN' | translate }}
                </span>
              </a>
            </li>
          }
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<ng-template #UploadFileDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="acceptanceAllowed"
    (confirm)="acceptanceAllowed ? onAcceptUploadFileDialog() : null"
    (cancel)="onCloseUploadFileDialog()"
    id="UploadFileDialog"
    modalTitle="{{ 'UPLOAD_ATTACHMENT_TITLE' | translate }}"
    acceptButtonLbl="{{ 'OK' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="">
    @if (
      uploadFileModel.fileToUpload !== undefined &&
      uploadFileModel.fileToUpload !== null &&
      uploadFileModel.fileToUpload.size > maxFileUploadSize
    ) {
      <span>
        <label class="px-0 small text-muted red-bold">{{ 'UPLOAD_ATTACHMENT_FILE_SIZE' | translate }}</label>
      </span>
    }
    <div class="row">
      <div class="input-group col-8">
        <input (change)="onFileInput($event)" class="form-control" id="inputGroupFile" type="file" />
        <label
          [attr.data-browse]="'UPLOAD_ATTACHMENT_CHOOSE' | translate"
          class="input-group-text"
          for="inputGroupFile">
          {{ uploadFileModel.filename }}
        </label>
      </div>
    </div>

    @if (isTopicVisible()) {
      <div class="row p-1"></div>
      <div class="row col-5 p-2">
        <h5>
          <b>{{ 'RECOURSE_CAMPAIGN_DETAIL_TOPIC' | translate }}</b>
        </h5>
      </div>
      <div class="row justify-content-start">
        <pas-select
          [(ngModel)]="uploadFileModel.topic"
          [options]="topicDropdownValues"
          (ngModelChange)="onSelectTopic(fileUploadTopicSelection.selectedOption)"
          class="col-5"
          #fileUploadTopicSelection
          placeholder="{{ 'CHOOSE_ONE' | translate }}"></pas-select>
      </div>
    }
  </tur-generic-modal-content>
</ng-template>

<ng-template #DuplicateCampaignDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="true"
    (confirm)="onAcceptDuplicateCampaignDialog()"
    (cancel)="onCloseDuplicateCampaignDialog()"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="{{ 'DUPLICATE_CAMPAIGN_OPERATION_ID' | translate }}">
    <pas-input [(ngModel)]="operationId" [maxLength]="10"></pas-input>
    <div class="d-flex justify-content-center">
      @if (spinnerActive) {
        <pas-spinner [size]="'small'"></pas-spinner>
      }
    </div>
  </tur-generic-modal-content>
</ng-template>
